module.exports = __webpack_public_path__ + "img/error.a686a94a.svg";